import React from 'react';
import { FiCheck, FiX } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const PricingComparison = () => {
  const features = [
    { name: "Precio por hora", oce: "$175 MXN ($10)", preply: "$261 MXN", italki: "$175-350 MXN", wse: "$2,333+ MXN", duolingo: "$145/año" },
    { name: "Profesor nativo certificado", oce: true, preply: true, italki: "Mayoría no", wse: true, duolingo: false },
    { name: "Diseñado para mexicanos", oce: true, preply: "Genérico", italki: "Genérico", wse: true, duolingo: "Genérico" },
    { name: "Salas 24/7 gratis", oce: true, preply: false, italki: false, wse: false, duolingo: false },
    { name: "Garantía devolución 3 clases", oce: true, preply: false, italki: false, wse: false, duolingo: false },
    { name: "Clínicas gramática incluidas", oce: "En planes+", preply: false, italki: false, wse: "Limitadas", duolingo: false },
    { name: "Flexibilidad de horarios", oce: "100% flexible", preply: "Flexible", italki: "Flexible", wse: "Rígida", duolingo: true },
    { name: "Certificación IELTS/TOEFL", oce: "Disponible", preply: "Limitado", italki: "Limitado", wse: true, duolingo: false },
  ];

  const renderValue = (val) => {
    if (val === true) return <SafeIcon icon={FiCheck} className="text-green-500 mx-auto text-xl" />;
    if (val === false) return <SafeIcon icon={FiX} className="text-red-500 mx-auto text-xl" />;
    return <span className="text-xs font-bold text-gray-400">{val}</span>;
  };

  return (
    <div className="py-20 px-4 bg-zinc-950">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-4 uppercase">
            Comparativa <span className="text-yellow-500">Real</span>
          </h2>
          <p className="text-gray-400">Por qué 50,000+ estudiantes nos prefieren sobre la competencia.</p>
        </div>

        <div className="overflow-x-auto rounded-[2rem] border border-zinc-800 shadow-2xl bg-zinc-900/50 backdrop-blur-xl">
          <table className="w-full text-center border-collapse">
            <thead>
              <tr className="bg-black/50 text-[10px] font-black uppercase tracking-widest text-gray-500 border-b border-zinc-800">
                <th className="p-6 text-left">Característica</th>
                <th className="p-6 text-yellow-500 bg-yellow-500/5">OCE (Nosotros)</th>
                <th className="p-6">Preply</th>
                <th className="p-6">italki</th>
                <th className="p-6">Academias (WSE)</th>
                <th className="p-6">Apps (Duolingo)</th>
              </tr>
            </thead>
            <tbody>
              {features.map((f, i) => (
                <tr key={i} className="border-b border-zinc-800/50 hover:bg-white/5 transition-colors">
                  <td className="p-6 text-left text-sm font-bold text-white uppercase tracking-tight">{f.name}</td>
                  <td className="p-6 bg-yellow-500/5 font-black text-green-400">{renderValue(f.oce)}</td>
                  <td className="p-6">{renderValue(f.preply)}</td>
                  <td className="p-6">{renderValue(f.italki)}</td>
                  <td className="p-6">{renderValue(f.wse)}</td>
                  <td className="p-6">{renderValue(f.duolingo)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default PricingComparison;